module.exports = __webpack_public_path__ + "img/songxiaojie_pink.0acb5a32.png";